(ns ui.editors.nev-view-editor.view-preview
  (:require
   [reagent.core :as r]
   [re-frame.core :as rf]
   [ui.editors.nev-view-editor.sub :as sub]
   [ui.editors.nev-view-editor.event :as event]
   [ui.editors.nev-view-editor.model :as model]
   [oops.core :as oops]
   [ui.util :as uu]
   [common.localization :as loc]
   [common.util :as cu]
   [ui.components.radix-ui.dialog.view :as dialog-primitive]
   [ui.editors.labelled-input.view :as labelled-input]))

(def device-width
  (->> model/preview-device-options
       (map (fn [{:keys [width value]}]
              [value width]))
       (into {})))

(defn device-type-selector
  []
  (let [device @(rf/subscribe [::sub/preview-device])]
    [:div
     {:class "flex rounded border border-solid border-base-light-border-paler overflow-hidden"}
     (->> model/preview-device-options
          (map (fn [{:keys [value label icon-class width]}]
                 (let [selected? (= value device)]
                   ^{:key (str value)}
                   [:button
                    {:on-pointer-down #(rf/dispatch [::event/set-preview-device value])
                     :class (uu/cm  "w-10 h-8 flex items-center justify-center"
                                    (when selected?
                                      "bg-base-regular shadow-inner"))}
                    [:i {:class (uu/cm icon-class
                                       (when-not selected?
                                         "text-base-light-text-paler"))}]]))))]))

(defn preview-entity-selector
  []
  (let [preview-entity-id @(rf/subscribe [::sub/preview-entity-id])
        entity-type @(rf/subscribe [::sub/view-entity-type])
        preview-entity-options @(rf/subscribe [::sub/preview-entity-options])]
    [:div
     [labelled-input/view
      {:value (->> preview-entity-options
                   (cu/filter-by :value preview-entity-id)
                   (first))
       :on-change #(rf/dispatch [::event/set-preview-entity-id %])
       :options preview-entity-options
       :data-type :data.type/ref-single
       :label (loc/tr :select-entity-type-for-preview
                      [(cu/str-trim-lcase (loc/tr entity-type))])}]]))

;; HACK: for hiding sidebar on the left side to achieve the slide in from left effect
;; on smaller preview device widths
(defn sidebar-mask
  [{:keys [preview-container*]}]
  (when-let [preview-container @preview-container*]
    (let [rect (oops/ocall preview-container "getBoundingClientRect")
          left (oops/oget rect "left")
          top (oops/oget rect "top")]
      [:<>
       [dialog-primitive/dialog-root
        {:open true
         :modal false}
        [dialog-primitive/dialog-portal
         [dialog-primitive/dialog-content
          {:style {"--preview-mask-top" (str top "px")
                   "--preview-mask-left" (str left "px")}
           :class (uu/cm "fixed left-0 top-[var(--preview-mask-top)] h-[calc(100vh-var(--preview-mask-top))] w-[100px] z-[211] bg-base-light"
                         "border border-y-0 border-l-0 w-[var(--preview-mask-left)]")}]]]])))

;; FIXME: This does not respect sections yet
(defn view
  [_props]
  (let [preview-container* (r/atom nil)]
    (fn [{:keys [render-preview]}]
      (let [device @(rf/subscribe [::sub/preview-device])
            preview-width (get device-width device)]
        [:div
         {:class "h-full max-h-full overflow-hidden flex flex-col justify-between relative"}
         [:div
          {:class "py-2 px-4 flex justify-between items-center
                   border-b border-solid border-base-light-border-paler"}
          [:div
           {:class "min-w-72"}
           [preview-entity-selector]]
          [:div
           [device-type-selector]]]
         [:div
          {:class "w-full flex relative grow overflow-hidden"}
          [:div
           {:ref #(reset! preview-container* %)
            :class "flex flex-col grow overflow-hidden overflow-y-auto mx-auto"
            :style {:width preview-width
                    :max-width preview-width}}
           [:div
            {:id "nev-preview-sidebar-sheet-container"
             :class "relative"}]
           (render-preview)
           (when-not (= device :desktop)
             [sidebar-mask
              {:preview-container* preview-container*}])]]]))))
